import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { UserNotification } from 'src/app/services/messaging/models';
import { NotificationCenterService } from 'src/app/services/notification-center/notification-center.service';

@Component({
    selector: 'app-notification-bell',
    templateUrl: './notification-bell.component.html',
    styleUrls: ['./notification-bell.component.scss'],
    standalone: false,
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  public notifications: UserNotification[] = [];
  public unreadCount = 0;
  public showDropdown = false;

  private notificationsSubscription: Subscription;
  private unreadSubscription: Subscription;

  constructor(
    private notificationCenter: NotificationCenterService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.notificationCenter.startListening();

    this.notificationsSubscription = this.notificationCenter.notifications$.subscribe(
      notifications => this.notifications = notifications,
    );

    this.unreadSubscription = this.notificationCenter.unreadCount$.subscribe(
      count => this.unreadCount = count,
    );
  }

  ngOnDestroy(): void {
    this.notificationsSubscription?.unsubscribe();
    this.unreadSubscription?.unsubscribe();
    this.notificationCenter.stopListening();
  }

  public toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  public closeDropdown(): void {
    this.showDropdown = false;
  }

  public async onNotificationClick(notification: UserNotification): Promise<void> {
    if (!notification.read) {
      await this.notificationCenter.markAsRead(notification.id);
    }

    this.showDropdown = false;
    const queryParams: Record<string, string> = { conversationId: notification.conversationId };
    if (notification.threadId) {
      queryParams.threadId = notification.threadId;
    }
    this.router.navigate(['messaging'], { queryParams });
  }

  public async markAllRead(): Promise<void> {
    await this.notificationCenter.markAllAsRead();
  }

  public getTimeAgo(timestamp: number): string {
    const seconds = Math.floor((Date.now() - timestamp) / 1000);

    if (seconds < 60) {
      return 'now';
    }
    if (seconds < 3600) {
      return `${Math.floor(seconds / 60)}m`;
    }
    if (seconds < 86400) {
      return `${Math.floor(seconds / 3600)}h`;
    }
    return `${Math.floor(seconds / 86400)}d`;
  }

  public getNotificationIcon(type: string): string {
    switch (type) {
      case 'mention':
        return 'at-outline';
      case 'thread_reply':
        return 'chatbubbles-outline';
      case 'channel_invite':
        return 'mail-outline';
      default:
        return 'notifications-outline';
    }
  }
}
